<div
    class="card"
    [class.exporting]="project?.statuses?.general === ProjectStatusEnum.EXPORTING"
    [class.minimal]="minimal">
    <div
        class="card__exporting-overlay"
        (mouseenter)="$event.stopPropagation()"
        *ngIf="project.statuses?.general === ProjectStatusEnum.EXPORTING">
        <div class="in-progress" matTooltip="Exporting">
            <div class="progress-text">{{ this.projectExportPercentage }}% Ready</div>
            <div class="progress-mask" [ngStyle]="{ width: this.projectExportPercentage + '%' }"></div>
        </div>
    </div>
    <div
        class="card__image"
        (mouseenter)="playAnimation(this.project.iconLayout._id)"
        (mouseleave)="pauseAnimation(this.project.iconLayout._id)">
        <!--        <div class="free-project" *ngIf="toDisplayTrialBanner">🎁 Trial Project</div>-->
        <div *ngIf="!project?.isProjectOwner" class="free-project">
            <mat-icon class="small-share-icon">share</mat-icon>
            Shared With Me
        </div>
        <dynamic-lottie
            [config]="{
                layout: this.project.iconLayout,
                dynamicLottieChanges: this.personalizedDynamics,
            }"
            [lottieOptions]="{ autoplay: false }"
            (animationCreated)="animationCreated($event, this.project.iconLayout._id)">
        </dynamic-lottie>
    </div>
    <!-- <div
[style.background-image]="'url(' + config.baseCdnUrl + project.icon + ')'"
class="card__image"
alt=""></div> -->
    <div class="card__overlay">
        <div class="card__header">
            <div class="card__header-text">
                <h3 class="card__title">{{ project.name }}</h3>
                <span class="card__statusarea row-spacebetween" *ngIf="!minimal || showOnlyStatus">
                    <ng-container *ngIf="showOnlyStatus; else fullStatusTemplate">
                        <span>
                            {{ project.isProjectOwner ? 'Created by me' : 'Shared with me' }} ●
                            {{ formattedCreationTime }}
                        </span>
                        <div
                            *ngIf="
                                project?.statuses?.general !== ProjectStatusEnum.DONE &&
                                project?.statuses?.general !== ProjectStatusEnum.EDITING
                            "
                            class="card__statusarea__status onlyStatus"
                            [ngClass]="project?.statuses?.general ?? ''">
                            <ng-container *ngTemplateOutlet="projectType"></ng-container>
                            {{ project?.statuses?.general ?? '' }}
                        </div>
                        <div
                            *ngIf="project?.statuses?.general === ProjectStatusEnum.EDITING"
                            class="card__statusarea__status onlyStatus"
                            [ngClass]="project?.statuses?.general ?? ''">
                            <ng-container *ngTemplateOutlet="projectType"></ng-container>

                            Reviewing
                        </div>
                        <div
                            *ngIf="project?.statuses?.general === ProjectStatusEnum.DONE"
                            class="card__statusarea__status onlyStatus export"
                            [ngClass]="project?.statuses?.general ?? ''"
                            [matBadge]="project.edits?.length - 1 ?? 0"
                            matBadgeSize="small">
                            <ng-container *ngTemplateOutlet="projectType"></ng-container>

                            Exports
                        </div>
                    </ng-container>
                    <ng-template #fullStatusTemplate>
                        {{ project.isProjectOwner ? 'Created by me' : 'Shared with me' }} ●
                        {{ formattedCreationTime }}
                        <div
                            *ngIf="
                                project?.statuses?.general !== ProjectStatusEnum.DONE &&
                                project?.statuses?.general !== ProjectStatusEnum.EDITING
                            "
                            class="card__statusarea__status"
                            [ngClass]="project?.statuses?.general ?? ''">
                            <ng-container *ngTemplateOutlet="projectType"></ng-container>
                            {{ project?.statuses?.general ?? '' }}
                        </div>
                        <div
                            *ngIf="project?.statuses?.general === ProjectStatusEnum.EDITING"
                            class="card__statusarea__status"
                            [ngClass]="project?.statuses?.general ?? ''">
                            <ng-container *ngTemplateOutlet="projectType"></ng-container>
                            Reviewing
                        </div>
                        <div
                            *ngIf="project?.statuses?.general === ProjectStatusEnum.DONE"
                            class="card__statusarea__status"
                            [ngClass]="project?.statuses?.general ?? ''"
                            [matBadge]="project.edits?.length - 1 ?? 0">
                            <ng-container *ngTemplateOutlet="projectType"></ng-container>
                            {{ project.edits?.length > 2 ? 'Exports' : 'Export' }}
                        </div>
                    </ng-template>
                </span>
            </div>
        </div>
        <ng-template #projectType>
            <mat-icon
                class="project-type-icon"
                [matTooltip]="
                    project.videoType === ProjectRecordingTypeEnum.AI_VOICE
                        ? 'AI Voice Project'
                        : ProjectRecordingTypeEnum.CAMERA === project.videoType
                          ? 'Video Project'
                          : 'Voiceover Project'
                ">
                {{ project.videoType === ProjectRecordingTypeEnum.AI_VOICE ? 'auto_awesome' : 'portrait' }}
            </mat-icon>
        </ng-template>
        <p class="card__description" *ngIf="!showOnlyStatus">Prompt: {{ project.creative?.prompt }}</p>
    </div>
</div>
